/* eslint-disable import/order */
/* eslint-disable camelcase */
import { sentenceCase } from 'change-case';
import { useState, useCallback, useEffect } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import {
  Card,
  Table,
  Avatar,
  Button,
  Container,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  IconButton
} from '@mui/material';
// routes
import axios, { getErrorMessage } from 'utils/axios';
import useIsMountedRef from 'hooks/useIsMountedRef';
import CRUD from 'utils/Crud';
import { fDate, fDateTime } from 'utils/formatTime';
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';
import { useSnackbar } from 'notistack';
// components
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
// sections
import { DataGrid } from '@mui/x-data-grid';
import { fNumber } from 'utils/formatNumber';
import { LoadingButton } from '@mui/lab';
import CustomGridToolbar from 'components/CustomGridToolbar';
import SearchQueryDailog from 'sections/@dashboard/SearchQueryDailog';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import ProfileDialog from 'sections/@dashboard/user/ProfileDialog';
import Label from 'components/Label';
import ViewJSONDailog from 'sections/@dashboard/ViewJSONDailog';
import ImportCruiseDialog from 'sections/@dashboard/featured-posts/ImportCruiseDialog';
import Swal from 'sweetalert2';
import AppColors from 'utils/AppColors';


export default function CruiseBatchManagement() {
  // const theme = useTheme();
  const { themeStretch } = useSettings();
  const isMountedRef = useIsMountedRef();
  const [data, setData] = useState([]);
  const [state,setState] = useState({loading:false,loadComplete:false,error:null});
  const [importModal,setImportModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();


  useEffect(() => {
    getInitData();
  }, []);

  return (
    <Page title="Manage Cruise">
      <Container maxWidth={themeStretch ? false : 'lg'}>
      <HeaderBreadcrumbs
          heading="Cruise Batch Importation"
          links={[
            { name: 'Cruise center', href: PATH_DASHBOARD.cruiseCenter.root },
            { name: 'Manage Batch' },
          ]}
          action={
            <>

              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setImportModal(true);
                }}
                startIcon={<Iconify icon="mdi:download-box" width={20} height={20} />}
                sx={{ mr: 2 }}
              >
                Import Batch Cruise
              </Button>

            </>
          }
        />


        {!state.loading && state.error !=null && (
          <Card>
            <Box padding={10} display={"flex"} justifyContent={"center"}>
            <p>Error {state.error} </p>
            </Box>
          </Card>
        )}

        <Card>
          
            <Box sx={{ height: 650, width: '100%' }}>
            <DataGrid
              rows={ state.error !=null ? [] : data}
              columns={[
                
                {
                  field: 'name',
                  headerName: 'Batch Name',
                  width: 180,
                  editable: false,
                },
                {
                  field: 'count',
                  headerName: 'Total Cruise',
                  width: 180,
                  editable: false,
                },
                {
                  field: 'staff_name',
                  headerName: 'Created By',
                  width: 180,
                  editable: false,
                },
                {
                  field: 'created_at',
                  headerName: 'Created at',
                  width: 180,
                  editable: false,
                  valueGetter: (params) => fDate(params.value),
                },
                {
                  field: "actions",
                  type: "actions",
                  align: "right",
                  width: 280,
                  headerName: "Actions",
                  getActions: (params) => [
                    <Button 
                    key={1}
                      variant='text' color="error"
                      onClick={()=> {
                        removeEntry(params.row);
                      }}
                      startIcon={<Iconify icon={'eva:trash-fill'} /> }
                      >
                        Delete Forever
                    </Button>
                  ],
                },
              ]}
              
              loading={state.loading}
              checkboxSelection
              disableRowSelectionOnClick
              components={{ Toolbar: CustomGridToolbar }}
              disableSelectionOnClick

            />
          </Box>
        </Card>
        

      </Container>


      {importModal &&  <ImportCruiseDialog
        open={importModal}
        handleClose={()=>{
          setImportModal(false);
        }}
        handleComplete={()=>{
          setImportModal(false);
          getInitData();
        }}
         />}


    </Page>
  );

  async function getInitData() {
    
    setState({...state,loading:true,loadComplete:false,error:null});

    try {

      const {data} = await axios.get(CRUD.cruise.batch);

      if (isMountedRef.current) {
        setData(data);
        setState({...state,loading:false,loadComplete:true,error:null})
      }
      
    } catch (error) {
      // console.error(error);
      setState({...state,loading:false,loadComplete:false,error: getErrorMessage(error)})
    }
  };


  function removeEntry(row){
    Swal.fire({
        text: "Do you want to delete this batch and its Cruises?",
        icon: 'warning',
        showCancelButton: true,
        // eslint-disable-next-line import/no-named-as-default-member
        confirmButtonColor: AppColors.DANGER,
        confirmButtonText: "Yes, contine",
        reverseButtons: true,
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
        preConfirm: async ()  =>  {
          try {
            await axios.delete(`${CRUD.cruise.batch}/${row.batch_id}`);
            const dat = data.filter(e=>e.id !== row.id);
            setData(dat);
            return true;
          } catch (error) {
            Swal.showValidationMessage(
                `${getErrorMessage(error) || error.toString()}`
            );
            return false;
          }
        },
    }).then((result) => {
        if (result.value) {
            Swal.close();
        } 
    });

  }

}
